import { useSelector } from 'react-redux'

import { useFormField } from 'cng-common/features/form'
import { useCurrencyRestriction } from 'partner360/components/currenciesButtons/hooks/useCurrencyRestriction'
import { selectQbrCurrency, selectQbrNetNdp, selectRounding } from 'partner360/features/QBR'

import { QBR_SETTINGS_FORM_KEY } from '../../../configs'

export const useFormCurrencySettings = () => {
  const netNdp = useSelector(selectQbrNetNdp)
  const currency = useSelector(selectQbrCurrency)
  const rounding = useSelector(selectRounding)

  const {
    value: currencyValue,
    handleChange: changeCurrency,
    isModified: isCurrencyModified,
  } = useFormField({
    formKey: QBR_SETTINGS_FORM_KEY,
    field: 'currency',
    defaultValue: currency,
  })

  const {
    value: netNdpValue,
    handleChange: changeNetNdp,
    isModified: isNetNdpModified,
  } = useFormField({
    formKey: QBR_SETTINGS_FORM_KEY,
    field: 'netNdp',
    defaultValue: netNdp,
  })

  const {
    value: roundingValue,
    handleChange: changeRounding,
    isModified: isRoundingModified,
  } = useFormField({
    formKey: QBR_SETTINGS_FORM_KEY,
    field: 'rounding',
    defaultValue: rounding,
  })

  const currencyRestriction = useCurrencyRestriction(currencyValue, changeCurrency)

  return {
    currencyValue: currencyRestriction.currency,
    isCurrencyModified,
    changeCurrency: currencyRestriction.changeCurrency,
    isCurrencyDisabled: currencyRestriction.isMultiLocalCurrencyLocked,

    netNdpValue,
    isNetNdpModified,
    changeNetNdp,

    roundingValue,
    isRoundingModified,
    changeRounding,
  }
}
